import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import quotes from './quotes';
class Quote extends Component {

    componentWillMount(){
        this.quote = this.getQuote();
    }

    getQuote(){
        var i = Math.floor(Math.random() * quotes.length);
        return quotes[i];
    }

    render() { 
        return (
            <div className="col-sm-6 hidden-xs quote-container">
                <q>{ReactHtmlParser(this.quote)}</q>
            </div>
        );
    }
}

export default Quote;


// WEBPACK FOOTER //
// ./src/components/Quote/Quote.js